import { render } from "./Presets.vue?vue&type=template&id=95d7948c"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"

import "./Presets.vue?vue&type=style&index=0&id=95d7948c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__